import { EventStreamCodec } from '@smithy/eventstream-codec';
import { fromUtf8, toUtf8 } from '@smithy/util-utf8';

export const SAMPLE_RATE = 44100;
export const mediaStreamCodec = new EventStreamCodec(toUtf8, fromUtf8);

export function concatUint8Arrays(chunks: Uint8Array[]): Uint8Array {
  const total = chunks.reduce((acc, curr) => acc + curr.length, 0);
  const result = new Uint8Array(total);
  let offset = 0;

  // eslint-disable-next-line no-restricted-syntax
  for (const chunk of chunks) {
    result.set(chunk, offset);
    offset += chunk.length;
  }
  return result;
}

export function getSilentFrame(durationMs = 4) {
  const samples = Math.floor(SAMPLE_RATE * (durationMs / 1000));
  const silentPcm = new Int16Array(samples); // 16-bit signed PCM, all zeros = silence
  return new Uint8Array(silentPcm.buffer);
}

export const formatAudioMessage = (chunk: any) => {
  const message = mediaStreamCodec.encode({
    headers: {
      ':message-type': { type: 'string', value: 'event' },
      ':event-type': { type: 'string', value: 'AudioEvent' },
    },
    body: chunk,
  });

  return message;
};

export function handleTranscribeMessage(buffer: ArrayBuffer, sendToServer: any) {
  const decoded = mediaStreamCodec.decode(new Uint8Array(buffer));
  const jsonText = new TextDecoder('utf-8').decode(decoded.body);
  const response = JSON.parse(jsonText);

  const results = response.Transcript?.Results;
  if (results && results.length && !results[0]?.IsPartial) {
    const result = results[0].Alternatives[0];

    let text = '';
    if (result.Items && result.Items.length > 0) {
      result.Items.forEach((item: { Type: string; Content: string; Confidence: number }) => {
        if (item.Type === 'punctuation') text += `${item.Content}`;
        if (item.Confidence > 0.2) text += ` ${item.Content}`;
      });
    }

    if (text.length > 0) {
      const end = result.Items[result.Items.length - 1].EndTime;
      sendToServer({ end, text, source: 'aws_transcribe' });
    }
  }
}
